<template>
    <!-- <UnderConstruction /> -->
    <div class="p-md-3 w-100">
      <div class="row pb-md-2 pb-3 pt-0">
        <div class="col-md-12 d-flex justify-content-start align-items-center">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb p-0 m-0">
              <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
              <li class="breadcrumb-item active" aria-current="page"> Payment Methods</li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="mt-3">
        <iframe src="https://tipmrebuilders.com/payment-methods/payment-methods/" frameborder="0" width="100%" height="700px" @load="onIframeLoad"></iframe>
      </div>
    </div>
</template>
    
<script lang="js">
import { defineComponent } from 'vue'
// import UnderConstruction from '../components/UnderConstruction';
import Mixin from '../mixins/global.mixin'
  
export default defineComponent({
  name: 'PaymentMethods',
  mixins: [Mixin],
  components: {
    // UnderConstruction
  },
  data() {
    return {
      iframeLoaded: false,
    }
  },
  methods: {
    onIframeLoad() {
      this.iframeLoaded = true;
      this.toggleFullScreenSpinner(false);
    },
  },
  mounted() {
  }
});
</script>
    